import bearer from '@websanova/vue-auth/drivers/auth/bearer'
import axios from '@websanova/vue-auth/drivers/http/axios.1.x'
import routerDriver from '@websanova/vue-auth/drivers/router/vue-router.2.x'
import appRouter from '../router'

export const LOGIN_REDIRECT_STORAGE_KEY = 'auth_redirect_after_login';

const authConfig = {
    auth: bearer,
    http: axios,
    router: routerDriver,
    tokenDefaultName: 'auth_token',
    tokenStore: ['localStorage'],
    rolesVar: 'roles',
    loginData: {url: 'auth/login', method: 'POST', redirect: '', fetchUser: true},
    logoutData: {url: 'auth/logout', method: 'POST', redirect: '/login', makeRequest: true},
    refreshData: {url: 'auth/refresh', method: 'GET', enabled: true, interval: 30},
    fetchData: {url: 'user', method: 'GET', enabled: true},
    responseIntercept: function (res, req) {
        if (req && req.ignoreVueAuth) {
            return;
        }

        if (this.options.http._invalidToken && this.options.http._invalidToken.call(this, res)) {
            const currentRoute = appRouter.currentRoute;
            const currentPath = currentRoute && (currentRoute.fullPath || currentRoute.path);

            if (currentPath && currentRoute.path !== '/login') {
                sessionStorage.setItem(LOGIN_REDIRECT_STORAGE_KEY, currentPath);
            }

            this.options.logoutProcess.call(this, res, {
                redirect: {
                    path: '/login',
                    query: {
                        authExpired: '1'
                    }
                }
            });

            return;
        }

        const token = this.options.auth.response.call(this, res);

        if (token) {
            this.token(null, token);
        }
    },
    parseUserData: function (data) {
        return Object.assign({}, data)
    }
};

export default authConfig
